'use client';

import { useState, useTransition } from 'react';
import Image from 'next/image';
import { resetPasswordAction } from '@/app/auth/actions';

export default function ForgotPasswordPage() {
  const [email, setEmail]            = useState('');
  const [message, setMessage]        = useState('');
  const [error, setError]            = useState('');
  const [isPending, startTransition] = useTransition();

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email.trim()) {
      setError('Enter your email address first.');
      return;
    }

    startTransition(async () => {
      const result = await resetPasswordAction(email);
      if (result.error) {
        setError(result.error);
      } else {
        setMessage('Check your email for a reset link.');
      }
    });
  }

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-cream-card border border-rule rounded-sm px-8 py-9 shadow-[0_4px_24px_rgba(14,20,32,0.08)]">
          <div className="flex items-center gap-2.5 mb-8">
            <Image src="/logo.png" alt="" width={32} height={32} className="h-8 w-8 shrink-0" />
            <div>
              <div className="font-sans font-bold text-[20px] text-navy leading-none">IntegrePro</div>
              <div className="text-[9px] uppercase tracking-[0.2em] text-ink-muted mt-1">Lighthouse</div>
            </div>
          </div>

          <h1 className="font-bold text-navy text-[18px] mb-6">Reset your password</h1>

          {message ? (
            <p className="text-[13px] text-[#3D5A2F] bg-[#E6F0E0] border border-[#B8D4AC] rounded-sm px-4 py-3">
              {message}
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-[11px] uppercase tracking-wider text-ink-muted mb-1.5" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  required
                  autoComplete="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full px-3 py-2 text-[13px] border border-rule rounded-sm bg-white focus:outline-none focus:border-navy"
                />
              </div>
              {error && <p className="text-[12px] text-prio-red">{error}</p>}
              <button
                type="submit"
                disabled={isPending}
                className="w-full py-2.5 text-[13px] font-medium text-white bg-[#F4622A] rounded-sm hover:opacity-90 transition-opacity disabled:opacity-60"
              >
                {isPending ? 'Sending...' : 'Send reset link'}
              </button>
            </form>
          )}

          <div className="mt-5 text-center">
            <a href="/login" className="text-[11px] text-ink-muted hover:text-navy transition-colors">
              Back to sign in
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
